import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    TelegramShareButton,
    WhatsappShareButton,
    LineShareButton,
    EmailShareButton,
    FacebookIcon,
    TwitterIcon,
    TelegramIcon,
    WhatsappIcon,
    LinkedinIcon,
    LineIcon,
    EmailIcon,
  } from 'react-share';

class SocialShare extends Component {
    render() {

        const { shareURL, title, hashtagarray } = this.props

        return (
            <div className="social-share">
                <span title="Bagikan"><FontAwesome name="share"/></span>
                <div title="Email">
                    <EmailShareButton
                        url={shareURL}
                        subject={title}>
                        <EmailIcon
                        size={30}
                        round={true} />
                    </EmailShareButton>
                </div>
                <div title="Facebook">
                    <FacebookShareButton
                    url={shareURL}
                    quote={title}>
                    <FacebookIcon
                        size={30}
                        round={true} />
                    </FacebookShareButton>
                </div>
                <div title="Twitter">
                    <TwitterShareButton
                    url={shareURL}
                    title={title}
                    hashtag={hashtagarray} //array
                    >
                    <TwitterIcon
                        size={30}
                        round={true} />
                    </TwitterShareButton>
                </div>
                <div title="Linkedin">
                    <LinkedinShareButton
                        url={shareURL}>
                        <LinkedinIcon
                        size={30}
                        round={true} />
                    </LinkedinShareButton>
                </div>
                <div title="Whatsapp">
                    <WhatsappShareButton
                    url={shareURL}
                    title={title}>
                    <WhatsappIcon
                        size={30}
                        round={true} />
                    </WhatsappShareButton>
                </div>
                <div title="Telegram">
                    <TelegramShareButton
                    url={shareURL}
                    title={title}>
                    <TelegramIcon
                        size={30}
                        round={true} />
                    </TelegramShareButton>
                </div>
                <div title="Line">
                    <LineShareButton
                        url={shareURL}
                        title={title}>
                        <LineIcon
                        size={30}
                        round={true} />
                    </LineShareButton>
                </div>
            </div>
        )
    }
}

export default SocialShare